import { ColorPickerConfig } from 'editor/src/store/hostSettings/types';
import { RootState } from 'editor/src/store/index';

const getSpreadColorPickerConfig = (state: RootState, spreadIndex: number): ColorPickerConfig => {
  const technology = state.design.designData?.spreads[spreadIndex]?.technology;
  const { colorPickerConfig, colorPickerConfigByTechnology } = state.hostSettings;
  return (technology && colorPickerConfigByTechnology?.[technology]) || colorPickerConfig;
};

export default getSpreadColorPickerConfig;
